import { gql } from '@apollo/client'

export const GET_EMAIL_ANALYTICS_HERO_STATS = gql`
  query GetEmailAnalyticsHeroStats($filters: EmailLogFiltersInput) {
    emailAnalyticsHeroStats(filters: $filters) {
      current {
        totalEmail
        outboundEmail
        inboundEmail
        automatedEmail
        timeSavedSeconds
      }
      previous {
        totalEmail
        outboundEmail
        inboundEmail
        automatedEmail
        timeSavedSeconds
      }
    }
  }
`

export const GET_EMAIL_VOLUME = gql`
  query GetEmailVolume($input: EmailVolumeInput!) {
    emailVolume(input: $input) {
      bucket
      series {
        direction
        points {
          periodStart
          count
        }
      }
    }
  }
`

export const GET_EMAIL_ACTIVITY_BY_EMPLOYEE = gql`
  query GetEmailActivityByEmployee($filters: EmailLogFiltersInput) {
    emailActivityByEmployee(filters: $filters) {
      total
      items {
        rowId
        rowName
        isSystemActor
        outbound
        inbound
      }
    }
  }
`
